import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileEditFormComponent } from './profile-edit-form.component';
import {
  DxButtonModule,
  DxFileUploaderModule,
  DxFormModule,
  DxLoadIndicatorModule,
  DxLoadPanelModule,
  DxScrollViewModule
} from 'devextreme-angular';
import {ProfilePhotoUploadModule} from '../profile-photo-upload/profile-photo-upload.module';



@NgModule({
  declarations: [ProfileEditFormComponent],
  imports: [
    CommonModule,
    DxFormModule,
    DxScrollViewModule,
    DxFileUploaderModule,
    DxButtonModule,
    DxLoadIndicatorModule,
    DxLoadPanelModule,
    ProfilePhotoUploadModule,
  ],
  exports: [ProfileEditFormComponent]
})
export class ProfileEditFormModule { }
